import { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { TextLink } from '../../../common/html/TextLink'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { NotificationMsg } from './common/notificationMsg'
import {
  changeData,
  changeIndexRegulationData,
  data,
  selectIndexRegulationData,
  selectLegalRegulationData,
  selectLegalRegulations,
  selectYearChangeFiscalYear,
} from './store/slice'

export const Notifications = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const dataTable = useSelector(data)
  const legalRegulationsList = useSelector(selectLegalRegulations)
  const legalRegulationData = useSelector(selectLegalRegulationData)
  const yearChangeFiscalYear = useSelector(selectYearChangeFiscalYear)
  const indexRegulationData = useSelector(selectIndexRegulationData)

  const handleReportFormId = (id) => {
    if (!id || legalRegulationsList.length === 0) {
      return undefined
    }
    return legalRegulationsList?.filter((item) => item.reportFormId === id)?.[0]
      .reportFormCode
  }

  const renderChangeReportCodeChildren = () => {
    return legalRegulationData.map(
      ({ isLastData, yearChange, oldReportId, newReportId, years }, index) => {
        const isActive = indexRegulationData === index

        if (!isLastData) {
          if (isActive) {
            return (
              <div key={index} style={{ marginTop: index ? 8 : 0 }}>
                <Translate
                  value="financialStatement.CHANGE_LEGAL_REGULATION_2"
                  yearChange={yearChange}
                  oldReportForm={handleReportFormId(oldReportId)}
                  newReportForm={handleReportFormId(newReportId)}
                  years={years.join(', ')}
                  isTextDecoration={false}
                />
              </div>
            )
          }

          return (
            <div key={index} style={{ marginTop: index ? 8 : 0 }}>
              <TextLink
                id={`legalChange${index}`}
                value="financialStatement.CHANGE_LEGAL_REGULATION"
                yearChange={yearChange}
                oldReportForm={handleReportFormId(oldReportId)}
                newReportForm={handleReportFormId(newReportId)}
                years={years.join(', ')}
                onClick={() => changeLegalRegulationData(index)}
                labelLink={I18n.t('financialStatement.HERE')}
                isTextDecoration={false}
              />
            </div>
          )
        }

        if (isActive) {
          return <Fragment key={index} />
        }

        return (
          <div key={index} style={{ marginTop: index ? 8 : 0 }}>
            <TextLink
              id={`legalChange${index}`}
              value="financialStatement.BACK_CHANGE_LEGAL_REGULATION"
              yearChange={yearChange + 1}
              onClick={() => changeLegalRegulationData(index)}
              labelLink={I18n.t('financialStatement.HERE')}
              isTextDecoration={false}
            />
          </div>
        )
      },
    )
  }

  const renderChangeFiscalYearEnd = () => {
    return (
      <>
        {yearChangeFiscalYear &&
          yearChangeFiscalYear.map((itemYear, index) => {
            const oldFiscalYearEnd = dataTable.find(
              (dataItem) => dataItem.realYear === itemYear.year,
            )?.fiscalYearEnd
            const newFiscalYearEnd = dataTable.find(
              (dataItem) => dataItem.realYear === itemYear.year + 1,
            )?.fiscalYearEnd
            return (
              <div key={index}>
                <Translate
                  value={'financialStatement.CHANGE_FISCAL_END_YEAR'}
                  fiscalYearEndChangeYear={itemYear.year + 1}
                  oldFiscalYearEnd={formatDateTime(
                    oldFiscalYearEnd,
                    FORMAT.DAY_MONTH,
                    locale,
                  )}
                  newFiscalYearEnd={formatDateTime(
                    newFiscalYearEnd,
                    FORMAT.DAY_MONTH,
                    locale,
                  )}
                />
              </div>
            )
          })}
      </>
    )
  }

  const changeLegalRegulationData = (index) => {
    dispatch(changeIndexRegulationData(index))
    dispatch(changeData(legalRegulationData[index].data))
  }

  const isHasManyReportForm = legalRegulationData.length > 1

  return (
    <>
      <Element
        style={{
          marginTop: isHasManyReportForm || yearChangeFiscalYear ? 12 : 0,
        }}
      >
        {isHasManyReportForm && (
          <NotificationMsg render={renderChangeReportCodeChildren} />
        )}
        {yearChangeFiscalYear && (
          <NotificationMsg render={renderChangeFiscalYearEnd} />
        )}
      </Element>
    </>
  )
}
